import { createContext, useContext } from "react";

const LinkContext = createContext({});

export const LinkContextProvider = LinkContext.Provider;
export const LinkContextConsumer = LinkContext.Consumer;

export const useLinkContext = () => useContext(LinkContext);

export default LinkContext;
